// === Header Component ===

import { getElements } from '../utils/dom.js';
import { updateTimelinePills } from './timeline.js';

export function updateHeaderDisplay() {
  updateTimelinePills();
}

export function setupScrollBehavior() {
  const els = getElements();
  let lastScrollY = window.scrollY;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > 50) {
          if (currentScrollY > lastScrollY) {
            els.appHeader.classList.add('header-hidden');
          } else {
            els.appHeader.classList.remove('header-hidden');
          }
        } else {
          els.appHeader.classList.remove('header-hidden');
        }

        lastScrollY = currentScrollY;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}
